export default "__VITE_ASSET__DzADfMQ0__"